import Icon from "../Icon";
import { ToggleButton } from "./ToggleButton";
import { ExpandingTooltipReturn } from "../hooks/useAdvancedTooltip";
import "../../styles/buttons/onOffToggle.css";

export { OnOffToggle };

type Props = {
  /**
   * class names
   */
  className?: string;
  /**
   * Controls how component is displayed.
   */
  active: boolean;
  onClick: () => void;
  /**
   * Text element to display within the button.
   */
  children: string;
  /**
   * Used to provide altText to the Icon. If nothing is used, the child text will be used as the alt text
   */
  altText?: string;
  tProps?: ExpandingTooltipReturn["triggerProps"];
};

/**
 *
 * @param props
 * @returns
 */
const OnOffToggle = (props: Props) => {
  return (
    <ToggleButton
      className={`onOffToggle ${props.active ? "active" : "inactive"} ${props.className ?? ""}`}
      active={props.active}
      onClick={props.onClick}
      tProps={props.tProps}
    >
      {props.children}
      <Icon
        icon={props.active ? "check" : "times"}
        altText={
          props.altText ??
          `Toggle ${props.active ? "Off" : "On"} ${props.children}`
        }
      />
    </ToggleButton>
  );
};
